// Kategorie- und Regionen-Mapping für lokalisierte Anzeige

export const CATEGORY_NAMES = {
  world: 'Welt',
  politics: 'Politik',
  economy: 'Wirtschaft',
  finance: 'Finanzen',
  technology: 'Technologie',
  science: 'Wissenschaft',
  health: 'Gesundheit',
  climate: 'Klima',
  sports: 'Sport',
  entertainment: 'Unterhaltung',
  gaming: 'Gaming',
  auto: 'Auto',
  space: 'Raumfahrt'
};

export const REGION_NAMES = {
  world: 'Welt',
  germany: 'Deutschland',
  austria: 'Österreich',
  switzerland: 'Schweiz',
  france: 'Frankreich',
  uk: 'Großbritannien',
  italy: 'Italien',
  spain: 'Spanien',
  usa: 'USA',
  canada: 'Kanada',
  mexico: 'Mexiko',
  china: 'China',
  japan: 'Japan',
  india: 'Indien',
  australia: 'Australien',
  brazil: 'Brasilien',
  russia: 'Russland',
  // Legacy
  europe: 'Europa',
  'north-america': 'Nordamerika',
  asia: 'Asien',
  africa: 'Afrika',
  'south-america': 'Südamerika',
  oceania: 'Ozeanien'
};

export const getCategoryName = (id) => CATEGORY_NAMES[id] || id;
export const getRegionName = (id) => REGION_NAMES[id] || id;
